// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Overlay */
.apm-overlay {
  position: fixed;
  inset: 0;
  z-index: 1300;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Panel */
.apm-panel {
  background: #ffffff;
  border-radius: 14px;
  width: 400px;
  max-width: calc(100vw - 32px);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.16);
  animation: apmFadeIn 0.18s ease;
}

@keyframes apmFadeIn {
  from { opacity: 0; transform: scale(0.97); }
  to   { opacity: 1; transform: scale(1); }
}

/* Header */
.apm-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.apm-tag {
  font-size: 0.68rem;
  font-weight: 600;
  color: #9ca3af;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  margin: 0 0 4px 0;
}

.apm-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #111827;
  margin: 0;
}

.apm-close {
  background: none;
  border: none;
  cursor: pointer;
  color: #6b7280;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: background 0.15s;
  flex-shrink: 0;
  margin-top: 2px;
}

.apm-close:hover {
  background: #f3f4f6;
  color: #111827;
}

/* Form */
.apm-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Field */
.apm-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.apm-label {
  font-size: 0.82rem;
  font-weight: 500;
  color: #374151;
}

.apm-input {
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 0.95rem;
  font-weight: 400;
  color: #111827;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  transition: border-color 0.15s;
  font-family: inherit;
  background: #fff;
}

.apm-input:focus {
  border-color: #0860e6;
}

.apm-input::placeholder {
  color: #9ca3af;
}

/* Price row */
.apm-price-row {
  display: flex;
  align-items: stretch;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  transition: border-color 0.15s;
}

.apm-price-row:focus-within {
  border-color: #0860e6;
}

.apm-price-prefix {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  font-size: 0.95rem;
  font-weight: 600;
  color: #374151;
  background: #f9fafb;
  border-right: 1.5px solid #e5e7eb;
  flex-shrink: 0;
}

.apm-price-input {
  border: none !important;
  border-radius: 0 !important;
  flex: 1;
  min-width: 0;
}

.apm-price-input:focus {
  border-color: transparent !important;
}

/* Prep Station custom dropdown */
.apm-dropdown {
  position: relative;
  width: 100%;
}

.apm-dropdown-trigger {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 0.95rem;
  font-weight: 400;
  color: #111827;
  background: #fff;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  transition: border-color 0.15s;
}

.apm-dropdown-trigger:hover,
.apm-dropdown-trigger.open {
  border-color: #0860e6;
}

.apm-dropdown-placeholder {
  color: #9ca3af;
}

.apm-dropdown-chevron {
  flex-shrink: 0;
  color: #6b7280;
  transition: transform 0.18s;
}

.apm-dropdown-chevron.rotated {
  transform: rotate(180deg);
}

.apm-dropdown-menu {
  /* position + coordinates injected via inline style (position: fixed) */
  background: #fff;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.14);
  display: flex;
  flex-direction: column;
  height: 240px;
  overflow: hidden;
}

.apm-dropdown-search {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-bottom: 1px solid #f3f4f6;
  background: #f9fafb;
}

.apm-dropdown-search-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 0.88rem;
  color: #111827;
  background: transparent;
  font-family: inherit;
}

.apm-dropdown-search-input::placeholder {
  color: #9ca3af;
}

.apm-dropdown-list {
  flex: 1;
  overflow-y: auto;
  padding: 4px 0;
  min-height: 0;
}

.apm-dropdown-list::-webkit-scrollbar {
  width: 4px;
}

.apm-dropdown-list::-webkit-scrollbar-thumb {
  background: #e5e7eb;
  border-radius: 2px;
}

.apm-dropdown-item {
  width: 100%;
  text-align: left;
  padding: 9px 14px;
  border: none;
  background: transparent;
  font-size: 0.92rem;
  font-weight: 400;
  color: #111827;
  cursor: pointer;
  font-family: inherit;
  transition: background 0.1s;
}

.apm-dropdown-item:hover {
  background: #f3f4f6;
}

.apm-dropdown-item.selected {
  background: #eff6ff;
  color: #0860e6;
  font-weight: 500;
}


.apm-dropdown-empty {
  padding: 12px 14px;
  font-size: 0.88rem;
  color: #9ca3af;
  text-align: center;
}

/* Actions */
.apm-actions {
  display: flex;
  gap: 10px;
  padding-top: 4px;
}

.apm-btn-cancel {
  flex: 1;
  padding: 11px;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  background: #ffffff;
  color: #374151;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
  font-family: inherit;
}

.apm-btn-cancel:hover {
  background: #f3f4f6;
  border-color: #d1d5db;
}

.apm-btn-add {
  flex: 2;
  padding: 11px;
  border: none;
  border-radius: 10px;
  background: #0860e6;
  color: #ffffff;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, opacity 0.15s;
  font-family: inherit;
}

.apm-btn-add:hover:not(.disabled) {
  background: #0752c4;
}

.apm-btn-add.disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* ═══ DARK THEME — AddProductModal ═══ */
.dark .apm-panel {
  background: #1e293b;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}
.dark .apm-tag   { color: #64748b; }
.dark .apm-title { color: #f1f5f9; }
.dark .apm-close { color: #64748b; }
.dark .apm-close:hover { background: #334155; color: #e2e8f0; }
.dark .apm-label { color: #94a3b8; }

.dark .apm-input {
  background: #0f172a;
  border-color: #334155;
  color: #f1f5f9;
}
.dark .apm-input:focus  { border-color: #0860e6; }
.dark .apm-input::placeholder { color: #475569; }

.dark .apm-price-row { border-color: #334155; }
.dark .apm-price-row:focus-within { border-color: #0860e6; }
.dark .apm-price-prefix {
  background: #0f172a;
  border-right-color: #334155;
  color: #94a3b8;
}

.dark .apm-dropdown-trigger {
  background: #0f172a;
  border-color: #334155;
  color: #f1f5f9;
}
.dark .apm-dropdown-trigger:hover,
.dark .apm-dropdown-trigger.open { border-color: #0860e6; }
.dark .apm-dropdown-placeholder { color: #475569; }
.dark .apm-dropdown-chevron { color: #64748b; }

.dark .apm-dropdown-menu {
  background: #1e293b;
  border-color: #334155;
}
.dark .apm-dropdown-search {
  background: #0f172a;
  border-bottom-color: #334155;
}
.dark .apm-dropdown-search-input { color: #f1f5f9; }
.dark .apm-dropdown-search-input::placeholder { color: #475569; }
.dark .apm-dropdown-item { color: #e2e8f0; }
.dark .apm-dropdown-item:hover { background: #334155; }
.dark .apm-dropdown-item.selected { background: rgba(8,96,230,0.15); color: #60a5fa; }
.dark .apm-dropdown-empty { color: #64748b; }

.dark .apm-btn-cancel {
  background: #1e293b;
  border-color: #334155;
  color: #e2e8f0;
}
.dark .apm-btn-cancel:hover {
  background: #334155;
  border-color: #475569;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/AddProductModal/AddProductModal.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,OAAO,UAAU,EAAE,mBAAmB,EAAE;AAC1C;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;EAC5B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,8BAA8B;EAC9B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,OAAO;EACP,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uEAAuE;EACvE,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;AACA,mBAAmB,cAAc,EAAE;AACnC,mBAAmB,cAAc,EAAE;AACnC,mBAAmB,cAAc,EAAE;AACnC,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;AAC9D,mBAAmB,cAAc,EAAE;;AAEnC;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA,0BAA0B,qBAAqB,EAAE;AACjD,gCAAgC,cAAc,EAAE;;AAEhD,uBAAuB,qBAAqB,EAAE;AAC9C,oCAAoC,qBAAqB,EAAE;AAC3D;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;mCACmC,qBAAqB,EAAE;AAC1D,kCAAkC,cAAc,EAAE;AAClD,8BAA8B,cAAc,EAAE;;AAE9C;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;AACA,mCAAmC,cAAc,EAAE;AACnD,gDAAgD,cAAc,EAAE;AAChE,2BAA2B,cAAc,EAAE;AAC3C,iCAAiC,mBAAmB,EAAE;AACtD,oCAAoC,+BAA+B,EAAE,cAAc,EAAE;AACrF,4BAA4B,cAAc,EAAE;;AAE5C;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":["/* Overlay */\n.apm-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1300;\n  background: rgba(0, 0, 0, 0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Panel */\n.apm-panel {\n  background: #ffffff;\n  border-radius: 14px;\n  width: 400px;\n  max-width: calc(100vw - 32px);\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.16);\n  animation: apmFadeIn 0.18s ease;\n}\n\n@keyframes apmFadeIn {\n  from { opacity: 0; transform: scale(0.97); }\n  to   { opacity: 1; transform: scale(1); }\n}\n\n/* Header */\n.apm-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.apm-tag {\n  font-size: 0.68rem;\n  font-weight: 600;\n  color: #9ca3af;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  margin: 0 0 4px 0;\n}\n\n.apm-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #111827;\n  margin: 0;\n}\n\n.apm-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #6b7280;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  transition: background 0.15s;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.apm-close:hover {\n  background: #f3f4f6;\n  color: #111827;\n}\n\n/* Form */\n.apm-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Field */\n.apm-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.apm-label {\n  font-size: 0.82rem;\n  font-weight: 500;\n  color: #374151;\n}\n\n.apm-input {\n  border: 1.5px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 10px 14px;\n  font-size: 0.95rem;\n  font-weight: 400;\n  color: #111827;\n  outline: none;\n  width: 100%;\n  box-sizing: border-box;\n  transition: border-color 0.15s;\n  font-family: inherit;\n  background: #fff;\n}\n\n.apm-input:focus {\n  border-color: #0860e6;\n}\n\n.apm-input::placeholder {\n  color: #9ca3af;\n}\n\n/* Price row */\n.apm-price-row {\n  display: flex;\n  align-items: stretch;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 10px;\n  overflow: hidden;\n  transition: border-color 0.15s;\n}\n\n.apm-price-row:focus-within {\n  border-color: #0860e6;\n}\n\n.apm-price-prefix {\n  display: flex;\n  align-items: center;\n  padding: 10px 12px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #374151;\n  background: #f9fafb;\n  border-right: 1.5px solid #e5e7eb;\n  flex-shrink: 0;\n}\n\n.apm-price-input {\n  border: none !important;\n  border-radius: 0 !important;\n  flex: 1;\n  min-width: 0;\n}\n\n.apm-price-input:focus {\n  border-color: transparent !important;\n}\n\n/* Prep Station custom dropdown */\n.apm-dropdown {\n  position: relative;\n  width: 100%;\n}\n\n.apm-dropdown-trigger {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 10px 14px;\n  font-size: 0.95rem;\n  font-weight: 400;\n  color: #111827;\n  background: #fff;\n  cursor: pointer;\n  text-align: left;\n  font-family: inherit;\n  transition: border-color 0.15s;\n}\n\n.apm-dropdown-trigger:hover,\n.apm-dropdown-trigger.open {\n  border-color: #0860e6;\n}\n\n.apm-dropdown-placeholder {\n  color: #9ca3af;\n}\n\n.apm-dropdown-chevron {\n  flex-shrink: 0;\n  color: #6b7280;\n  transition: transform 0.18s;\n}\n\n.apm-dropdown-chevron.rotated {\n  transform: rotate(180deg);\n}\n\n.apm-dropdown-menu {\n  /* position + coordinates injected via inline style (position: fixed) */\n  background: #fff;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 10px;\n  box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.14);\n  display: flex;\n  flex-direction: column;\n  height: 240px;\n  overflow: hidden;\n}\n\n.apm-dropdown-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border-bottom: 1px solid #f3f4f6;\n  background: #f9fafb;\n}\n\n.apm-dropdown-search-input {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-size: 0.88rem;\n  color: #111827;\n  background: transparent;\n  font-family: inherit;\n}\n\n.apm-dropdown-search-input::placeholder {\n  color: #9ca3af;\n}\n\n.apm-dropdown-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 4px 0;\n  min-height: 0;\n}\n\n.apm-dropdown-list::-webkit-scrollbar {\n  width: 4px;\n}\n\n.apm-dropdown-list::-webkit-scrollbar-thumb {\n  background: #e5e7eb;\n  border-radius: 2px;\n}\n\n.apm-dropdown-item {\n  width: 100%;\n  text-align: left;\n  padding: 9px 14px;\n  border: none;\n  background: transparent;\n  font-size: 0.92rem;\n  font-weight: 400;\n  color: #111827;\n  cursor: pointer;\n  font-family: inherit;\n  transition: background 0.1s;\n}\n\n.apm-dropdown-item:hover {\n  background: #f3f4f6;\n}\n\n.apm-dropdown-item.selected {\n  background: #eff6ff;\n  color: #0860e6;\n  font-weight: 500;\n}\n\n\n.apm-dropdown-empty {\n  padding: 12px 14px;\n  font-size: 0.88rem;\n  color: #9ca3af;\n  text-align: center;\n}\n\n/* Actions */\n.apm-actions {\n  display: flex;\n  gap: 10px;\n  padding-top: 4px;\n}\n\n.apm-btn-cancel {\n  flex: 1;\n  padding: 11px;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 10px;\n  background: #ffffff;\n  color: #374151;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s;\n  font-family: inherit;\n}\n\n.apm-btn-cancel:hover {\n  background: #f3f4f6;\n  border-color: #d1d5db;\n}\n\n.apm-btn-add {\n  flex: 2;\n  padding: 11px;\n  border: none;\n  border-radius: 10px;\n  background: #0860e6;\n  color: #ffffff;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s, opacity 0.15s;\n  font-family: inherit;\n}\n\n.apm-btn-add:hover:not(.disabled) {\n  background: #0752c4;\n}\n\n.apm-btn-add.disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* ═══ DARK THEME — AddProductModal ═══ */\n.dark .apm-panel {\n  background: #1e293b;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n}\n.dark .apm-tag   { color: #64748b; }\n.dark .apm-title { color: #f1f5f9; }\n.dark .apm-close { color: #64748b; }\n.dark .apm-close:hover { background: #334155; color: #e2e8f0; }\n.dark .apm-label { color: #94a3b8; }\n\n.dark .apm-input {\n  background: #0f172a;\n  border-color: #334155;\n  color: #f1f5f9;\n}\n.dark .apm-input:focus  { border-color: #0860e6; }\n.dark .apm-input::placeholder { color: #475569; }\n\n.dark .apm-price-row { border-color: #334155; }\n.dark .apm-price-row:focus-within { border-color: #0860e6; }\n.dark .apm-price-prefix {\n  background: #0f172a;\n  border-right-color: #334155;\n  color: #94a3b8;\n}\n\n.dark .apm-dropdown-trigger {\n  background: #0f172a;\n  border-color: #334155;\n  color: #f1f5f9;\n}\n.dark .apm-dropdown-trigger:hover,\n.dark .apm-dropdown-trigger.open { border-color: #0860e6; }\n.dark .apm-dropdown-placeholder { color: #475569; }\n.dark .apm-dropdown-chevron { color: #64748b; }\n\n.dark .apm-dropdown-menu {\n  background: #1e293b;\n  border-color: #334155;\n}\n.dark .apm-dropdown-search {\n  background: #0f172a;\n  border-bottom-color: #334155;\n}\n.dark .apm-dropdown-search-input { color: #f1f5f9; }\n.dark .apm-dropdown-search-input::placeholder { color: #475569; }\n.dark .apm-dropdown-item { color: #e2e8f0; }\n.dark .apm-dropdown-item:hover { background: #334155; }\n.dark .apm-dropdown-item.selected { background: rgba(8,96,230,0.15); color: #60a5fa; }\n.dark .apm-dropdown-empty { color: #64748b; }\n\n.dark .apm-btn-cancel {\n  background: #1e293b;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n.dark .apm-btn-cancel:hover {\n  background: #334155;\n  border-color: #475569;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
